import * as React from "react";
import { shopConfig } from "~/helpers/shopConfig";
import { PaymentMethod } from "~/payments";
import styled from "~/styled";

import afterpay from "../../assets/images/payment_methods/afterpay.png";
import alipay from "../../assets/images/payment_methods/alipay.png";
import amex from "../../assets/images/payment_methods/american-express.png";
import apple_pay from "../../assets/images/payment_methods/apple-pay.png";
import bancontact from "../../assets/images/payment_methods/bancontact.png";
import blik from "../../assets/images/payment_methods/blik.png";
import cartaSi from "../../assets/images/payment_methods/carta-si.png";
import carteBleue from "../../assets/images/payment_methods/carte-blue.png";
import dankort from "../../assets/images/payment_methods/dankort.png";
import eps from "../../assets/images/payment_methods/eps.png";
import giropay from "../../assets/images/payment_methods/giropay.png";
import ideal from "../../assets/images/payment_methods/ideal.png";
import klarna from "../../assets/images/payment_methods/klarna.png";
import maestro from "../../assets/images/payment_methods/maestro.png";
import master from "../../assets/images/payment_methods/master.png";
import multibanco from "../../assets/images/payment_methods/multibanco.png";
import myBank from "../../assets/images/payment_methods/my-bank.png";
import nexi from "../../assets/images/payment_methods/nexi.png";
import paypal from "../../assets/images/payment_methods/paypal.png";
import postepay from "../../assets/images/payment_methods/postepay.png";
import przelewy24 from "../../assets/images/payment_methods/przelewy.png";
import sepa from "../../assets/images/payment_methods/sepa.png";
import sofort from "../../assets/images/payment_methods/sofort.png";
import trustly from "../../assets/images/payment_methods/trustly.png";
import visa from "../../assets/images/payment_methods/visa.png";

interface IPaymentMethodIcon {
  [x: string]: any;
}

const paymentMethodIcons: IPaymentMethodIcon = {
  [PaymentMethod.AFTERPAY]: afterpay,
  [PaymentMethod.ALIPAY]: alipay,
  [PaymentMethod.AMEX]: amex,
  [PaymentMethod.BANCONTACT]: bancontact,
  [PaymentMethod.BLIK]: blik,
  [PaymentMethod.CARTA_SI]: cartaSi,
  [PaymentMethod.CARTE_BLEUE]: carteBleue,
  [PaymentMethod.DANKORT]: dankort,
  [PaymentMethod.EPS]: eps,
  [PaymentMethod.GIROPAY]: giropay,
  [PaymentMethod.IDEAL]: ideal,
  [PaymentMethod.KLARNA]: klarna,
  [PaymentMethod.MASTER_VISA]: [visa, master, maestro, apple_pay],
  [PaymentMethod.MULTIBANCO]: multibanco,
  [PaymentMethod.MY_BANK]: myBank,
  [PaymentMethod.NEXI]: nexi,
  [PaymentMethod.PAYPAL]: paypal,
  [PaymentMethod.POSTEPAY]: postepay,
  [PaymentMethod.PRZELEWY24]: przelewy24,
  [PaymentMethod.SEPA]: sepa,
  [PaymentMethod.SOFORT]: sofort,
  [PaymentMethod.TRUSTLY]: trustly
};

const PaymentIcons = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;

  img {
    width: 55px;
    height: 35px;
    margin: 10px;
  }
`;

class PaymentMethods extends React.Component {
  public render() {
    const { paymentMethods } = shopConfig;

    const availablePaymentMethods = paymentMethods.filter(paymentMethod =>
      Object.keys(paymentMethodIcons[paymentMethod])
    );

    const icons = [].concat(
      ...availablePaymentMethods.map(icon => paymentMethodIcons[icon])
    );

    return (
      <PaymentIcons>
        {icons.map((element, index) => (
          <img key={index} src={element} />
        ))}
      </PaymentIcons>
    );
  }
}

export default PaymentMethods;



// WEBPACK FOOTER //
// ./src/components/FAQ/PaymentMethods.tsx